import axios from 'axios';

const makeGetRequest = async (path) => {
  try {
    const { data } = await axios.get(path);

    return data;
  } catch (e) {
    return e;
  }
};

const makePostRequest = async (path, payload) => {
  try {
    const { data } = await axios.post(path, payload);

    return data;
  } catch (e) {
    return e;
  }
};

const makePutRequest = async (path, payload) => {
  try {
    const { data } = await axios.put(path, payload);

    return data;
  } catch (e) {
    return e;
  }
};

const makePatchRequest = async (path, payload) => {
  try {
    const { data } = await axios.patch(path, payload);

    return data;
  } catch (e) {
    return e;
  }
};

const makeDeleteRequest = async (path, payload) => {
  try {
    const { data } = await axios.delete(path, payload);

    return data;
  } catch (e) {
    return e;
  }
};

export {
  makeGetRequest,
  makePostRequest,
  makePutRequest,
  makePatchRequest,
  makeDeleteRequest,
};
